import script from "./BleControllerRegistPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BleControllerRegistPage.vue?vue&type=script&setup=true&lang=js"

import "./BleControllerRegistPage.vue?vue&type=style&index=0&id=1ef57a05&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef57a05"]])

export default __exports__